/**
 * Generate WhatsApp URL that works on all devices:
 * - iPhone/Android: uses api.whatsapp.com (opens native app)
 * - iPad: uses web.whatsapp.com (no native app exists for iPad)
 * - PC: uses api.whatsapp.com (offers app or web)
 */
export function getWhatsAppLink(phone, message) {
  const tel = (phone || '').replace(/\D/g, '');
  const encoded = encodeURIComponent(message);
  const ua = navigator.userAgent;
  const isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  const isIPhone = /iPhone/.test(ua);
  if (isIPad) return `https://web.whatsapp.com/send?phone=${tel}&text=${encoded}`;
  if (isIPhone) return `https://api.whatsapp.com/send?phone=${tel}&text=${encoded}`;
  return `https://api.whatsapp.com/send?phone=${tel}&text=${encoded}`;
}
